import { Component } from 'preact';
import { route } from 'preact-router';

import RecordsTable from '../records-table';
import handleLoadingAndError from '../handle-loading-and-error';
import { mapObj } from '../../utils/object-helpers';
import Selector from '../selector';
import { getMonthNames } from '../../utils/date-utils';
import Tabs from '../tabs';
import sizeAware from '../size-aware';
import style from './style.scss';

/**
 * The RecordsMonthly component is a view displayed on the History records page.
 * It displays a records table along with a month selector which allows users to see
 * records for each calendar month of the year.
 *
 * props:
 * - month: the current month number
 * - data: full data set of monthly records data
 */
class RecordsMonthly extends Component {

	onMonthSelected(option) {
		route(`/history-records/monthly/${option.routeSubview}`);
	}

	renderTabs() {
		const options = getMonthNames().map((month, i) => ({
			id: i + 1,
			label: month.slice(0, 3),
			routeSubview: month.toLowerCase()
		}));

		return (
			<Tabs options={options}
			      selectedId={this.props.month}
			      tabSelected={this.onMonthSelected}
			      isSecondary />
		);
	}

	renderSelector() {
		const options = getMonthNames().map((month, i) => ({
			value: i + 1,
			label: month,
			routeSubview: month.toLowerCase()
		}));

		return (
			<Selector options={options}
			          selectedValue={this.props.month}
			          onOptionSelect={this.onMonthSelected} />
		);
	}

	render(props) {
		if (props.month === null) {
			return null;
		}

		const data = mapObj(props.data, (param, items) => items.filter(item => item.month === props.month)[0]);

		return (
			<div class={style.monthly_records}>
				<div class={style.monthly_selector_wrapper}>
					{
						props.windowWidth < 600
							? this.renderSelector()
							: this.renderTabs()
					}
				</div>
				<RecordsTable data={data} isMonthly />
			</div>
		);
	}

}

export default handleLoadingAndError(sizeAware(RecordsMonthly));



// WEBPACK FOOTER //
// ./components/records-monthly/index.js